import { React, useEffect, useReducer, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form, Input } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, EditOutlined, UserSwitchOutlined} from '@ant-design/icons';

import axios from 'axios';
import usertypereducer from './reducer';
import { useNavigate } from 'react-router-dom';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useAuth } from '../../Context';
import { useFormik } from 'formik';
import { EDIT_USER_TYPES, EDIT_USER_TYPES_ERROR, EDIT_USER_TYPES_SUCCESS, USER_TYPES_DETAILS_ERROR, USER_TYPES_LIST, USER_TYPES_LIST_DETAILS, USER_TYPES_LIST_DETAILS_SUCCESS, USER_TYPES_LIST_ERROR, USER_TYPES_LIST_SUCCESS } from './constants';
const { Title } = Typography;



export default function UsertypeManagement() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {  userTypes : [], details: null, loading: false, error: false, users_data : []};
	const [data, dispatch] = useReducer(usertypereducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const navigate = useNavigate();
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	// const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	useAuth();
	
	

	const columns = [

		
		{
			title: `${langdata && langdata.UserType ? langdata.UserType:'UserType'}`,
			dataIndex: 'userType',
			key: 'userType',
			render: (_,record) => (
				record?.userType ?  record?.userType : 'No Data'
			)
			
		},
		{
			title: `${langdata && langdata.aliasName ? langdata.aliasName:'Alias Name'}`,
			dataIndex: 'aliasName',
			key: 'aliasName',
			render: (_,record) => (
				record?.aliasName ?  record?.aliasName : 'No Data'
			)
		},
	
	];

	if(permission==='superadmin' || permission === 'admin'){
		columns.push(
			{
				title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
				key: 'attachmentUrls',
				align:'center',
				render: (_,record) => (
					<>
						<Space style={{justifyContent:'center',display:'flex'}} size="middle">
							<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={()=>showEditDrawer(record)}><EditOutlined/></a>
						</Space>
					</>
				)
			});
	}


	
	useEffect(() => {
		if(featuresModule.dfosManagementEnabled == false) {
			navigate('/dashboard');
		}
		if(!authtoken){
			navigate('/');
		}
	
	},[authtoken]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4036);

	}, []);
	
	useEffect(() => {
		loadUserTypes();
	}, []);



	const loadUserTypes = () => {
		let url = `${api}/usertype?id[$ne]=1&$sort[userType]=1`;
		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			timeout: timeout,
			headers: {
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			}
		};
		
		dispatch({ type: USER_TYPES_LIST });
		
		axios.request(config).then((response) => {
			if (response && response.data) {
				dispatch( { type: USER_TYPES_LIST_SUCCESS, payload: response.data });
			} else {
				dispatch( { type: USER_TYPES_LIST_ERROR });
			}
		}).catch((error) => {
			console.log(error);
			dispatch( { type: USER_TYPES_LIST_ERROR });
			if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
				message.config({
					duration : 5,
					maxCount : 1,
				});
				message.open({
					type: 'error',
					content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
				});
			}
		});
	};
	
	
	



	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.UserTypeInfoContent ? langdata.UserTypeInfoContent :'User Type Management is a module that allows administrators to view and manage the different user types available in the system. It provides the ability to update the alias name and display name used to represent each user type throughout the application.'}</p>
		</Card>
	);


	const showEditDrawer = (record) => {
		loadusertypedetails(record);
		setOpenEditDrawer(true);
		
	};


	const editformik = useFormik({
		enableReinitialize: true,
		initialValues: {
			aliasName:data?.details?.aliasName || '',
		},
		onSubmit: (values) => {
			dispatch({type:EDIT_USER_TYPES});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/usertype/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					aliasName:values.aliasName
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_USER_TYPES_SUCCESS});
						Modal.success({ title: `${langdata && langdata.usertypedetailsUpdatedSuccessfully ? langdata.usertypedetailsUpdatedSuccessfully :'Usertype details updated successfully'}` });
						editformik.resetForm();
						setOpenEditDrawer(false);
						loadUserTypes();
					}
				})
				.catch((error) => {
					if(error.response){
						message.error(`${error.response.data.message}`);
					}
					console.log(error);
						
					dispatch({ type: EDIT_USER_TYPES_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadusertypedetails = ((record) => {
		dispatch( { type: USER_TYPES_LIST_DETAILS });
			
		if (!record) {
			dispatch({ type: USER_TYPES_DETAILS_ERROR });
		} else {
			dispatch({ type: USER_TYPES_LIST_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		editformik.resetForm();
		setOpenEditDrawer(false);

	};


	return (
		<>
			<Content>
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >

					<Col span={8}>
						<Row>

							<Space>
								<UserSwitchOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.UsertypeManagement ? langdata.UsertypeManagement:'User Type Management'}</Title>
						</Row>
					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.UsertypeManagement ? langdata.UsertypeManagement:'User Type Management'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.userTypes?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.userTypes} 
								onChange = { loadUserTypes }
								
								
							/>
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				
				<Modal
					title={langdata && langdata.EditUsertypeDetails ? langdata.EditUsertypeDetails:'Edit Usertype Details'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editformik.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editformik.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editformik.handleSubmit} layout="vertical"
						// onValuesChange={handleUpdateFormValuesChange}
					>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.aliasName ? langdata.aliasName : 'Alias Name'} name="name" rules={[{ required: true , message : langdata && langdata.PleaseEnterAliasName ? langdata.PleaseEnterAliasName : 'Please Enter Alias Name' }]}>
									<Input 
										name="aliasName"
										defaultValue={editformik.values.aliasName}
										onChange={editformik.handleChange} 
										placeholder={langdata && langdata.PleaseEnterAliasName ? langdata.PleaseEnterAliasName : 'Please Enter Alias Name' }
									/>
								</Form.Item>
							</Col>
						</Row>			

					</Form>
				</Modal>
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}